/** Basket panel width rules, kept out of the component file so they can be shared
 *  and unit-tested without tripping react-refresh's component-only export rule. */

export const BASKET_WIDTH_KEY = 'sift.brokerBasketWidth';
export const BASKET_DEFAULT_WIDTH = 460;
export const BASKET_MIN_WIDTH = 340;
export const BASKET_MAX_WIDTH = 900;

/** Keep the panel inside the viewport. The min wins on a very narrow window --
 *  a too-wide panel is recoverable, one narrower than its own controls is not. */
export const clampBasketWidth = (w: number, viewport?: number): number => {
  const vw = viewport ?? (typeof window === 'undefined' ? BASKET_DEFAULT_WIDTH : window.innerWidth);
  const ceiling = Math.max(BASKET_MIN_WIDTH, Math.min(BASKET_MAX_WIDTH, vw - 80));
  if (!Number.isFinite(w)) return BASKET_DEFAULT_WIDTH;
  return Math.min(Math.max(w, BASKET_MIN_WIDTH), ceiling);
};
